import { Search,CloseRounded as CloseIcon, Edit, ArrowDropUp } from "@mui/icons-material";
import { Button, Collapse, GridLegacy as Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  DialogType, FormActions, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";
import {KeyboardArrowDown,KeyboardArrowUp} from "@mui/icons-material";
import { SubTableProveedores } from "../../../components/plataforma/maestro-proveedores-logisticos/subtable-proveedores";


const schema = yup.object({
  tipo_empresa: yup.string().required(),
  razon_social: yup.string().required(),
  nit: yup.number().required(),
  nombre_contacto: yup.string().optional().notRequired().nullable(),
  telefono_contacto: yup.number().required(),
  email: yup.string().email().optional().notRequired().nullable(),
}).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const proveedorEntity = {
    tipo_empresa:null,
    razon_social:null,
    nit:null,
    nombre_contacto:null,
    telefono_contacto:null,
    email:null
}
export const MaestrosProoveedoresLogisticos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({
   ...proveedorEntity
  });
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);



    

    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("logistico/listar-proveedores",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data]);

     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      
      setProductoSeleccionado(product || {});
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...proveedorEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
        const urlService = 'logistico/crud-actualizar-logistico';
        console.log({dataForm});
        
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,dataForm)
        .then(async ({data})=>{

            if (data.status){
                setIsVisibleModalDetalle(false);
                await loadItems(true);
            }else{

                dispatch({
                    type:ActionTypes.setModalInfo,
                    data:{
                        title:"Error",
                        message:data.msg,
                        type:DialogType.peligro,
                        isVisible:true
                    }
                }); 
            }

        
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
   }
  
   const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }
   
   const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }
    const searchCpDestino = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOpDestino(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"tipo_empresa",
        keyValue:"tipo_empresa",
        label:"Tipo de usuario",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"Nombre o razon social",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"email",
        keyValue:"email",
        label:"Correo de contacto",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"telefono_contacto",
        keyValue:"telefono_contacto",
        label:"Telefono contacto",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"Activo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },

       
       {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar proveedor logistico":'Modificar proveedor logistico',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
            
          key:"tipo_empresa",
          keyValue:"tipo_empresa",
          label:"Tipo de usuario",
          component:SelectInputWithLabel,
          responsiveSize:12,
          inputProps:{
            type:"text",
            size:"small",
            items:[{
                label:"Independiente",
                value:"INDEPENDIENTE"
            },
            {
                label:"Empresa",
                value:"EMPRESA"
            }
        ]
          }
        },
        {
            key:"nit",
            keyValue:"nit",
            label:"Nit o documento",
            component:InputWithLabel,
            responsiveSize:6,
            inputProps:{
              type:"text"
            }
          },
        {
          key:"razon_social",
          keyValue:"razon_social",
          label:"Razon social o Nombre del proveedor",
          component:InputWithLabel,
          responsiveSize:6,
          inputProps:{
            type:"text"
          }
        },
        {
            key:"nombre_contacto",
            keyValue:"nombre_contacto",
            label:"Nombre de la persona de contacto",
            component:InputWithLabel,
            responsiveSize:12,
            inputProps:{
              type:"text"
            }
        },
        {
          key:"telefono_contacto",
          keyValue:"telefono_contacto",
          label:"Telefono de contacto",
          component:InputWithLabel,
          inputProps:{
            type:"number"
          }
        },
        {
          key:"email",
          keyValue:"email",
          label:"Correo de contacto",
          component:InputWithLabel,
          inputProps:{
            type:"email"
          }
        },
       
/*         {
          key:"activo",
          keyValue:"activo",
          label:"Estado",
          component:SelectInputWithLabel,
          inputProps:{
            items:[
              {
                value:"ACTIVO",
                label:"Activo"
              },
              {
                value:"INACTIVO",
                label:"Inactivo"
              },
              {
                value:"POR CONFIRMAR",
                label:"Por confirmar"
              }
            ],
            type:"select",
           // items: Object.keys(TiposVehiclos).map(keys=>({label:keys.replace(/-/g," "),value:TiposVehiclos[keys] }))
          }
        }, */
      ]
    } ;
 
    const onOpenTableCollapse = (index)=>{
      const copyData = [...dataSetProdctos];
      copyData[index].opened = !Boolean( copyData[index].opened );
      setDataSetProductos(copyData);
    }

    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar usuario"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo proveedor</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prodIndex)=>
                 [ <TableRow key={prod.cod}  >
                      <TableCell >
                        <IconButton onClick={e=>onOpenTableCollapse(prodIndex)} >
                        {prod.opened ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                      </TableCell>
                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>,
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} >
                  <SubTableProveedores
                 opened={prod.opened}
                 parentData={prod}
                 />
                  </TableCell>
                </TableRow>
                ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}